<template>
    <app-layout>
        <template #header>
            <div class="relative mb-6">
                <div class="absolute mb-4 right-0">
                    <div class="col-span-2">
                        <balance :short="true" />
                    </div>
                </div>
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                        <i class="fas fa-hand-holding-usd"></i>
                        Sacar valores
                    </h2>
                </div>
            </div>
        </template>
        <div>
            <div class="container max-w-7xl mx-auto px-8 py-20">
                <div class="flex flex-col lg:flex-row">
                    <div class="lg:pr-12 flex-grow flex-shrink-0">
                        <div
                            class="mb-9 bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4"
                        >
                            <flash :timeout="5000" />
                            <div>
                                <a :href="route('list-receive.listReceive')">
                                    <span class="font-bold text-xl">
                                        <i class="fas fa-arrow-left"></i>
                                        Valores a receber
                                    </span></a
                                >
                            </div>
                            <inertia-table
                                class="text-xs"
                                :enablePageSize="false"
                                :enableSearch="false"
                                :searchFilter="false"
                                :data="withdrawal"
                                :params="params"
                                :columns="columns"
                                routeName="list-receive.request-withdrawa"
                                parent="withdrawal"
                                id="id"
                            >
                                <template
                                    slot-scope="row"
                                    slot="movement.date_brt"
                                >
                                    <span
                                        v-if="row.item.movement.date_brt"
                                        class="text-left text-gray-700"
                                        >{{
                                            row.item.movement.date_brt
                                                | smallDateTime
                                        }}</span
                                    >
                                    <span v-else class="text-left text-gray-400"
                                        >--/--/----</span
                                    >
                                </template>

                                <template slot-scope="row" slot="origin">
                                    <div
                                        class="text-xs  text-left text-gray-400 uppercase"
                                    >
                                        {{ row.item.movement.name }}
                                    </div>
                                    <div class="text-left text-gray-500">
                                        <em class="fas fa-address-card"></em>
                                        {{ row.item.movement.federal_document }}
                                    </div>
                                </template>

                                <template slot-scope="row" slot="description">
                                    <div
                                        class="text-left font-semibold text-gray-600 toUpperCase"
                                    >
                                        {{ row.item.description }}
                                    </div>
                                    <div class="text-left text-gray-400">
                                        {{ row.item.descri_bank }}
                                    </div>
                                </template>

                                <template slot-scope="row" slot="amount">
                                    <div
                                        class=" w-full text-sm text-left font-bold text-blck"
                                    >
                                        R${{ row.item.amount | currency }}
                                    </div>
                                </template>
                            </inertia-table>
                        </div>
                    </div>
                    <div class="space-y-4">
                        <div class="flex-shrink-0 lg:ml-auto mb-5 lg:mb-0">
                            <div
                                class="p-6 py-8 w-64 h-52 bg-white overflow-hidden shadow-xl sm:rounded-lg"
                            >
                                <div
                                    class="mb-6 flex font-semibold items-center justify-center"
                                >
                                    Resumo
                                </div>

                                <div class="mt-8 flex space-x-16">
                                    <span class="text-lefth text-gray-400"
                                        >Quantidade</span
                                    >
                                    <p class="font-bold">
                                        {{ withdrawal.pendings.count }}
                                    </p>
                                </div>
                                <div class="mt-8 flex space-x-24">
                                    <span class="text-gray-400">Total</span>
                                    <p class="font-bold">
                                        R${{ withdrawal.pendings.priceFormat }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent="transfer()">
                            <div
                                class="container sm:col-span-2 mx-auto space-y-4"
                            >
                                <div
                                    class="p-6 py-8 w-64 h-64 bg-white overflow-hidden shadow-xl sm:rounded-lg"
                                >
                                    <div
                                        class="mb-6 flex font-semibold items-center justify-center"
                                    >
                                        Confirmar saque
                                    </div>
                                    <div
                                        class="mt-8 flex justify-center items-center space-y-2"
                                    >
                                        <jet-label
                                            for="google_code"
                                            value="Código de Autorização"
                                        />
                                    </div>
                                    <jet-input
                                        id="google_code"
                                        type="number"
                                        class="mt-1 block w-full"
                                        v-model="form.google_code"
                                    />
                                    <jet-input-error
                                        :message="form.error('google_code')"
                                        class="mt-2"
                                    />
                                    <div
                                        class="mt-1 flex justify-center items-center"
                                    >
                                        <jet-ok-button
                                            class="w-full py-3 mt-2 text-center bg-green-500 hover:bg-green-700 ounded px-8 text-white"
                                            type="submit"
                                        >
                                            Concluir e sacar
                                        </jet-ok-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import Flash from "../../Helpers/Flash";
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import Input from "../../Jetstream/Input";
import Balance from "../../Helpers/Balance";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetOkButton from "../../Jetstream/OkButton";
import JetInputError from "../../Jetstream/InputError";

export default {
    components: {
        Balance,
        Input,
        AppLayout,
        Welcome,
        Flash,
        JetAutoComplete,
        InertiaTable,
        JetLabel,
        JetInput,
        JetOkButton,
        JetInputError
    },
    props: ["withdrawal", "account", "errors"],
    data: function() {
        return {
            filters: [],
            params: {},

            form: this.$inertia.form(
                {
                    _method: "POST",
                    amount: this.withdrawal.pendings.price,
                    google_code: null
                },
                {
                    resetOnSuccess: false
                }
            ),

            columns: [
                {
                    text: "Data de realização",
                    className: "text-left text-gray-400",
                    key: "movement.date_brt",
                    sortable: true
                },
                {
                    text: "Origem",
                    className: "text-left text-gray-400",
                    key: "origin",
                    sortable: false
                },
                {
                    text: "Descrição",
                    className: "text-left text-gray-400",
                    key: "description",
                    sortable: false
                },
                {
                    text: "Valor",
                    className: "text-left text-gray-400",
                    key: "amount",
                    sortable: false
                }
            ]
        };
    },

    methods: {
        transfer() {
            if (this.form.amount > 0) {
                this.form.post("/json/withdraw", {
                    preserveScroll: true,
                    onError: e => {
                        clearTimeout(this.timer);
                        this.form.processing = false;
                        this.reviewTransfer = this.errors.google_code
                            ? true
                            : false;
                        this.form.google_code = null;
                        this.$forceUpdate();
                    },
                    onSuccess: () => {
                        clearTimeout(this.timer);
                    }
                });
            }
        }
    }
};
</script>
